import "./Loading.css"
import "./MainApp.css"

function Loading() {
    return (
        <div className="cell">
            <div className="pl pl-origami"></div>
	    </div>
    )
}

export default Loading;